export interface SportOption {
  value: string;
  label: string;
  icon: string;
  color: string;
}

export const sportOptions: SportOption[] = [
  { value: 'basketball', label: 'Basketball', icon: '🏀', color: 'from-orange-500 to-amber-500' },
  { value: 'soccer', label: 'Soccer', icon: '⚽', color: 'from-emerald-500 to-green-500' },
  { value: 'volleyball', label: 'Volleyball', icon: '🏐', color: 'from-blue-500 to-cyan-500' },
  { value: 'pickleball', label: 'Pickleball', icon: '🏓', color: 'from-lime-500 to-green-500' },
  { value: 'softball', label: 'Softball', icon: '🥎', color: 'from-yellow-500 to-amber-500' },
  { value: 'baseball', label: 'Baseball', icon: '⚾', color: 'from-red-500 to-rose-500' },
  { value: 'golf', label: 'Golf', icon: '⛳', color: 'from-teal-500 to-emerald-500' },
];

export const sportPlaceholders: Record<string, string> = {
  basketball: 'Downtown Basketball League',
  pickleball: 'Sunset Pickleball Club',
  soccer: 'Metro FC Community',
  golf: 'Riverside Golf Association',
  volleyball: 'Beachside Volleyball League',
  softball: 'Metro Softball Association',
  baseball: 'Riverview Baseball League',
};
